module.exports = __webpack_public_path__ + "static/blog70-2e2be12828f9995b107bb22d598f2735.png";